import { Link } from "react-router";
import type { PlaybookContentGuide } from "../../state/api.types";
import { PlaybookGuideCard } from "./PlaybookGuideCard";

const MAX_GUIDES_SHOWN = 4;

export const PlaybookGuideCardRow = ({
  title,
  guides,
  viewAllHref,
}: {
  title: React.ReactNode;
  guides: Pick<
    PlaybookContentGuide,
    "short_id" | "title" | "tagline" | "published_at"
  >[];
  viewAllHref?: string;
}) => {
  return (
    <div className="flex flex-col gap-3xl">
      <div className="flex justify-between">
        <h3 className="text-xl font-semibold">{title}</h3>
        {viewAllHref && (
          <Link to={viewAllHref} className="font-regular text-sm text-tertiary">
            View all
          </Link>
        )}
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(14.5rem,1fr))] gap-lg">
        {guides.slice(0, MAX_GUIDES_SHOWN).map((g) => (
          <PlaybookGuideCard key={g.short_id} className="w-full" guide={g} />
        ))}
      </div>
    </div>
  );
};
